export default __webpack_public_path__ + "static/agile-31a3b6b358e954b0b66dba7280de6571.png";